import { useState } from '#imports'
import { type ShallowRef, onBeforeUnmount } from 'vue'

import { useElementVisibility } from '@vueuse/core'

export function useAddToCartVisibility() {
  const containerAddToCartMobile = useState<ShallowRef<
    Readonly<HTMLElement | null>
  > | null>('pp-ContainerAddToCart-mobile', () => null)

  function registerElements(mobile: ShallowRef<Readonly<HTMLElement | null>>) {
    containerAddToCartMobile.value = mobile
  }

  function checkVisibility() {
    const isContainerAddToCartMobileViewport = useElementVisibility(
      containerAddToCartMobile.value,
    )

    return { isContainerAddToCartMobileViewport }
  }

  onBeforeUnmount(() => {
    containerAddToCartMobile.value = null
  })

  return {
    registerElements,
    checkVisibility,
  }
}
